import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {TextView} from '../../ui_canvas_engine/TextView'
import {GameFont} from '../../GameFont'
import {GameColor} from '../../GameColor'
import {UIGameHoverResourceInfoView} from '../UIGameHoverResourceInfoView'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {SpriteButtonView} from '../../ui_canvas_engine/SpriteButtonView'
import {TranslationObject} from '@colonist/i18n'
import {UIGameShakeAnimation} from '../../ui_canvas_engine/animation/UIGameShakeAnimation'
import {UIGameAnimationBase} from '../../ui_canvas_engine/animation/UIGameAnimationBase'
import {Point} from '@colonist/game-mechanic-validators'
import {CardEnum, PlayerColor} from '@colonist/game-states'

export class UIPlacementConfirmationButton extends SectionBgView {
    center: Point

    private readonly button: SpriteButtonView
    private buttonShakeAnimation: UIGameAnimationBase

    private resourceCardStates: UIGameHoverResourceInfoView | undefined

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, action: () => void, texture: PIXI.Texture, canTakeAction: boolean, myColor: PlayerColor, bankActionAmount?: number) {
        super(x, y, w, h, container, true)
        this.button = new SpriteButtonView(0, 0, w, h, this as any as PIXI.Container)
        this.button.updateAction(() => {
            if(canTakeAction) return action()

            this.shakeButton()
            this.resourceCardStates?.flickerMissingCards()
        })
        this.center = new Point(x + w / 2, y + h / 2)
        this.button.addCenteredIcon(texture)
        this.addBadge(myColor, canTakeAction, bankActionAmount)

        if(canTakeAction) return
        this.button.inactivateOpacity()
    }

    private shakeButton() {
        if(this.buttonShakeAnimation != undefined) this.buttonShakeAnimation.stop()
        this.buttonShakeAnimation = new UIGameShakeAnimation(this.button).start()
    }

    private addBadge(myColor: PlayerColor, canTakeAction: boolean, amount?: number) {
        if(amount === undefined) return

        const size = this.height / 3
        const buttonBorderX = this.width * 0.1
        const buttonBorderY = this.height * 0.04
        const badgeX = this.width - size
        const badgeTexture = UIGameSpriteHandler.getButtonBadgeForPlayer(myColor)
        const badgeSprite = new SpriteView(badgeX - buttonBorderX, buttonBorderY, size, size, this.button.viewContainer as any as PIXI.Container, badgeTexture)
        this.button.addAsset(badgeSprite)

        this.createCardCountText(amount)
    }

    private createCardCountText(count: number): TextView {
        const buttonBorderX = this.width * 0.1
        const buttonBorderY = this.height * 0.04
        const countText: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: count}}
        const countTextView = new TextView(countText, this.width * 0.8 - buttonBorderX, buttonBorderY, this.width, this.height,
            this.button.viewContainer as any as PIXI.Container, undefined, undefined, false)

        const fontSize = this.height / 5.5
        const maxNumberForOneDigitText = 9
        if(count > maxNumberForOneDigitText) countTextView.x -= this.width / 15

        const colorDarkGrey = GameColor.getColor(GameColor.Color.DarkGrey)
        const colorOffWhite = GameColor.getColor(GameColor.Color.OffWhite)

        countTextView.changeStyle({
            fontSize: fontSize + 'px',
            fill: colorOffWhite,
            fontWeight: GameFont.Weight.Bold,
            stroke: colorDarkGrey,
            strokeThickness: 2,
        })

        return countTextView
    }

    addResourceCardStates(cardEnums: CardEnum[], cardInventory: CardEnum[]) {
        this.resourceCardStates = new UIGameHoverResourceInfoView(cardEnums, this, this as any as PIXI.Container, cardInventory, false)
    }
}
